// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AcceptRa } from "./accept-ra";

/**
 * A tagged VLAN riding a NIC or a bond.
 */
export class VlanConfig implements flatbuffers.IUnpackableObject<VlanConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): VlanConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsVlanConfig(bb: flatbuffers.ByteBuffer, obj?: VlanConfig): VlanConfig {
    return (obj || new VlanConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsVlanConfig(bb: flatbuffers.ByteBuffer, obj?: VlanConfig): VlanConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new VlanConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(): string | null;
  id(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  id(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  tag(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * NicConfig or BondConfig id this VLAN rides.
   */
  link(): string | null;
  link(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  link(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dhcp4(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  dhcp6(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  acceptRa(): AcceptRa {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : AcceptRa.UNSET;
  }

  addresses(index: number): string;
  addresses(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  addresses(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  addressesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  gateway4(): string | null;
  gateway4(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gateway4(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  gateway6(): string | null;
  gateway6(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gateway6(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  mtu(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startVlanConfig(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addTag(builder: flatbuffers.Builder, tag: number) {
    builder.addFieldInt16(1, tag, 0);
  }

  static addLink(builder: flatbuffers.Builder, linkOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, linkOffset, 0);
  }

  static addDhcp4(builder: flatbuffers.Builder, dhcp4: boolean) {
    builder.addFieldInt8(3, +dhcp4, +false);
  }

  static addDhcp6(builder: flatbuffers.Builder, dhcp6: boolean) {
    builder.addFieldInt8(4, +dhcp6, +false);
  }

  static addAcceptRa(builder: flatbuffers.Builder, acceptRa: AcceptRa) {
    builder.addFieldInt8(5, acceptRa, AcceptRa.UNSET);
  }

  static addAddresses(builder: flatbuffers.Builder, addressesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, addressesOffset, 0);
  }

  static createAddressesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAddressesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addGateway4(builder: flatbuffers.Builder, gateway4Offset: flatbuffers.Offset) {
    builder.addFieldOffset(7, gateway4Offset, 0);
  }

  static addGateway6(builder: flatbuffers.Builder, gateway6Offset: flatbuffers.Offset) {
    builder.addFieldOffset(8, gateway6Offset, 0);
  }

  static addMtu(builder: flatbuffers.Builder, mtu: number) {
    builder.addFieldInt32(9, mtu, 0);
  }

  static endVlanConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createVlanConfig(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    tag: number,
    linkOffset: flatbuffers.Offset,
    dhcp4: boolean,
    dhcp6: boolean,
    acceptRa: AcceptRa,
    addressesOffset: flatbuffers.Offset,
    gateway4Offset: flatbuffers.Offset,
    gateway6Offset: flatbuffers.Offset,
    mtu: number,
  ): flatbuffers.Offset {
    VlanConfig.startVlanConfig(builder);
    VlanConfig.addId(builder, idOffset);
    VlanConfig.addTag(builder, tag);
    VlanConfig.addLink(builder, linkOffset);
    VlanConfig.addDhcp4(builder, dhcp4);
    VlanConfig.addDhcp6(builder, dhcp6);
    VlanConfig.addAcceptRa(builder, acceptRa);
    VlanConfig.addAddresses(builder, addressesOffset);
    VlanConfig.addGateway4(builder, gateway4Offset);
    VlanConfig.addGateway6(builder, gateway6Offset);
    VlanConfig.addMtu(builder, mtu);
    return VlanConfig.endVlanConfig(builder);
  }

  unpack(): VlanConfigT {
    return new VlanConfigT(
      this.id(),
      this.tag(),
      this.link(),
      this.dhcp4(),
      this.dhcp6(),
      this.acceptRa(),
      this.bb!.createScalarList<string>(this.addresses.bind(this), this.addressesLength()),
      this.gateway4(),
      this.gateway6(),
      this.mtu(),
    );
  }

  unpackTo(_o: VlanConfigT): void {
    _o.id = this.id();
    _o.tag = this.tag();
    _o.link = this.link();
    _o.dhcp4 = this.dhcp4();
    _o.dhcp6 = this.dhcp6();
    _o.acceptRa = this.acceptRa();
    _o.addresses = this.bb!.createScalarList<string>(
      this.addresses.bind(this),
      this.addressesLength(),
    );
    _o.gateway4 = this.gateway4();
    _o.gateway6 = this.gateway6();
    _o.mtu = this.mtu();
  }

  unpackFields(...fields: string[]): VlanConfigT {
    const t = new VlanConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id();
    }
    if (fieldSet.has("tag")) {
      t.tag = this.tag();
    }
    if (fieldSet.has("link")) {
      t.link = this.link();
    }
    if (fieldSet.has("dhcp4")) {
      t.dhcp4 = this.dhcp4();
    }
    if (fieldSet.has("dhcp6")) {
      t.dhcp6 = this.dhcp6();
    }
    if (fieldSet.has("accept_ra")) {
      t.acceptRa = this.acceptRa();
    }
    if (fieldSet.has("addresses")) {
      t.addresses = this.bb!.createScalarList<string>(
        this.addresses.bind(this),
        this.addressesLength(),
      );
    }
    if (fieldSet.has("gateway4")) {
      t.gateway4 = this.gateway4();
    }
    if (fieldSet.has("gateway6")) {
      t.gateway6 = this.gateway6();
    }
    if (fieldSet.has("mtu")) {
      t.mtu = this.mtu();
    }
    return t;
  }
}

export class VlanConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: string | Uint8Array | null = null,
    public tag: number = 0,
    public link: string | Uint8Array | null = null,
    public dhcp4: boolean = false,
    public dhcp6: boolean = false,
    public acceptRa: AcceptRa = AcceptRa.UNSET,
    public addresses: string[] = [],
    public gateway4: string | Uint8Array | null = null,
    public gateway6: string | Uint8Array | null = null,
    public mtu: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? builder.createString(this.id!) : 0;
    const link = this.link !== null ? builder.createString(this.link!) : 0;
    const addresses = VlanConfig.createAddressesVector(
      builder,
      builder.createObjectOffsetList(this.addresses),
    );
    const gateway4 = this.gateway4 !== null ? builder.createString(this.gateway4!) : 0;
    const gateway6 = this.gateway6 !== null ? builder.createString(this.gateway6!) : 0;

    return VlanConfig.createVlanConfig(
      builder,
      id,
      this.tag,
      link,
      this.dhcp4,
      this.dhcp6,
      this.acceptRa,
      addresses,
      gateway4,
      gateway6,
      this.mtu,
    );
  }

  clone(): VlanConfigT {
    const obj = new VlanConfigT();
    obj.id = this.id;
    obj.tag = this.tag;
    obj.link = this.link;
    obj.dhcp4 = this.dhcp4;
    obj.dhcp6 = this.dhcp6;
    obj.acceptRa = this.acceptRa;
    obj.addresses = [...this.addresses];
    obj.gateway4 = this.gateway4;
    obj.gateway6 = this.gateway6;
    obj.mtu = this.mtu;
    return obj;
  }

  equals(other: VlanConfigT): boolean {
    if (this.id !== other.id) return false;
    if (this.tag !== other.tag) return false;
    if (this.link !== other.link) return false;
    if (this.dhcp4 !== other.dhcp4) return false;
    if (this.dhcp6 !== other.dhcp6) return false;
    if (this.acceptRa !== other.acceptRa) return false;
    if (this.addresses.length !== other.addresses.length) return false;
    for (let i = 0; i < this.addresses.length; i++) {
      if (this.addresses[i] !== other.addresses[i]) return false;
    }
    if (this.gateway4 !== other.gateway4) return false;
    if (this.gateway6 !== other.gateway6) return false;
    if (this.mtu !== other.mtu) return false;
    return true;
  }
}

export function verifyVlanConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 22, 4);
  } finally {
    verifier.popDepth();
  }
}
